module.exports = __webpack_public_path__ + "img/9788939522688.db84dd7b.jpg";